import InfoBlock from "./InfoBlock";
import StatCard from "./StatCard";
import SubscribeButtons from "@/components/ui/SubscribeButtons";
import { QuestionStatistics } from "@/types/QuestionStatistics";
import cardBack from "@/assets/img/cards/d_10_wheel_of_fortune.png";
import cardDeck from "@/assets/img/d_card_deck.png";

interface LuckyCardFreeProps {
  onSubscriptionClick: () => void;
  onTelegramClick: () => void;
  statistics: QuestionStatistics | null;
}

export const LuckyCardFree = ({
  onSubscriptionClick,
  onTelegramClick,
  statistics,
}: LuckyCardFreeProps) => {
  return (
    <div className="flex flex-col items-center h-[calc(100svh-200px)] px-4">
      <InfoBlock text="Оформляйте подписку и участвуйте в еженедельном поиске 'Счастливой карты', в случае выигрыша задайте вопрос нашему астрологу" />

      <div className="flex w-full justify-center gap-4 py-2 ">
        <StatCard
          label="Отгадано карт"
          value={statistics?.guessedLuckyCardsCount.toString() ?? "0"}
        />
        <StatCard
          label="Задано вопросов"
          value={statistics?.resolvedQuestionsCount.toString() ?? "0"}
        />
      </div>

      <div className="flex flex-row justify-around w-full">
        <div className="text-white text-xs sm:text-sm mb-1 text-center opacity-70 font-medium w-full ">
          Ваша карта
        </div>
        <div className="text-white text-xs sm:text-sm mb-1 text-center opacity-70 font-medium w-full ">
          Счастливая карта
        </div>
      </div>

      <div
        style={{
          maxWidth: "100%",
          maxHeight: "40%",
          aspectRatio: "11/19",
          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <img
          src={cardBack}
          alt="card-back-center"
          className={` rounded-lg shadow bg-transparent`}
          style={{
            height: "90%",
            width: "auto",
            padding: "3px",
            backgroundColor: "white",
            objectFit: "cover",
            display: "block",
          }}
        />

        <img
          src={cardBack}
          alt="card-back-center"
          className={` rounded-lg shadow bg-transparent`}
          style={{
            height: "90%",
            width: "auto",
            padding: "3px",
            backgroundColor: "white",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>
      <div className="flex flex-col justify-end items-center gap-2 ">
        <img
          src={cardDeck}
          alt="card-back"
          className="w-full h-[15vh] object-contain "
        />
        <SubscribeButtons
          buttonText="Подписки"
          onButtonClick={onSubscriptionClick}
          onTelegramClick={onTelegramClick}
        />
      </div>
    </div>
  );
};
